import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "fe_token";

export const api = axios.create({ baseURL: API });

export function setAuthToken(token) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
    api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  } else {
    localStorage.removeItem(TOKEN_KEY);
    delete api.defaults.headers.common["Authorization"];
  }
}
export const getToken = () => localStorage.getItem(TOKEN_KEY);

// Restore token on load
const _t = getToken();
if (_t) api.defaults.headers.common["Authorization"] = `Bearer ${_t}`;

// Auto-logout on 401
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      setAuthToken(null);
      if (window.location.pathname !== "/") window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export const authRegister = (data) => api.post("/auth/register", data).then((r) => r.data);
export const authLogin = (data) => api.post("/auth/login", data).then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);
export const changePassword = (data) => api.post("/auth/change-password", data).then((r) => r.data);

export const getScripts = () => api.get("/scripts").then((r) => r.data);
export const getObjections = () => api.get("/objections").then((r) => r.data);
export const getTips = () => api.get("/tips").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getLeads = () => api.get("/leads").then((r) => r.data);
export const updateScript = (id, data) => api.put(`/scripts/${id}`, data).then((r) => r.data);
export const createScript = (data) => api.post("/scripts", data).then((r) => r.data);
export const deleteScript = (id) => api.delete(`/scripts/${id}`).then((r) => r.data);
export const createObjection = (data) => api.post("/objections", data).then((r) => r.data);
export const updateObjection = (id, data) => api.put(`/objections/${id}`, data).then((r) => r.data);
export const deleteObjection = (id) => api.delete(`/objections/${id}`).then((r) => r.data);
export const resetContent = () => api.post("/content/reset").then((r) => r.data);
export const getTemplates = () => api.get("/templates").then((r) => r.data);
export const createTemplate = (data) => api.post("/templates", data).then((r) => r.data);
export const updateTemplate = (id, data) => api.put(`/templates/${id}`, data).then((r) => r.data);
export const deleteTemplate = (id) => api.delete(`/templates/${id}`).then((r) => r.data);
export const createLead = (data) => api.post("/leads", data).then((r) => r.data);
export const updateLead = (id, data) => api.put(`/leads/${id}`, data).then((r) => r.data);
export const deleteLead = (id) => api.delete(`/leads/${id}`).then((r) => r.data);
export const bulkCreateLeads = (leads) => api.post("/leads/bulk", { leads }).then((r) => r.data);
export const logCallAttempt = (id, data) => api.post(`/leads/${id}/log-attempt`, data).then((r) => r.data);

// CRM config & admin
export const getPipelineStatuses = () => api.get("/pipeline-statuses").then((r) => r.data);
export const getCallOutcomes = () => api.get("/call-outcomes").then((r) => r.data);
export const getBranding = () => api.get("/auth/branding").then((r) => r.data);
export const updateBranding = (data) => api.put("/settings/branding", data).then((r) => r.data);
export const getServices = () => api.get("/services").then((r) => r.data);
export const createService = (data) => api.post("/services", data).then((r) => r.data);
export const updateService = (id, data) => api.put(`/services/${id}`, data).then((r) => r.data);
export const deleteService = (id) => api.delete(`/services/${id}`).then((r) => r.data);
export const getKbArticles = () => api.get("/kb-articles").then((r) => r.data);
export const createKbArticle = (data) => api.post("/kb-articles", data).then((r) => r.data);
export const updateKbArticle = (id, data) => api.put(`/kb-articles/${id}`, data).then((r) => r.data);
export const deleteKbArticle = (id) => api.delete(`/kb-articles/${id}`).then((r) => r.data);
export const getTeams = () => api.get("/teams").then((r) => r.data);
export const createTeam = (data) => api.post("/teams", data).then((r) => r.data);
export const updateTeam = (id, data) => api.put(`/teams/${id}`, data).then((r) => r.data);
export const deleteTeam = (id) => api.delete(`/teams/${id}`).then((r) => r.data);
export const revokeTeamAccess = (id) => api.post(`/teams/${id}/revoke-access`).then((r) => r.data);
export const getLeadAssignees = () => api.get("/leads/assignees").then((r) => r.data);
export const bulkAssignLeads = (data) => api.post("/leads/bulk-assign", data).then((r) => r.data);
export const getUsers = () => api.get("/users").then((r) => r.data);
export const createUser = (data) => api.post("/users", data).then((r) => r.data);
export const updateUser = (id, data) => api.put(`/users/${id}`, data).then((r) => r.data);
export const deactivateUser = (id) => api.post(`/users/${id}/deactivate`).then((r) => r.data);
export const createPipelineStatus = (data) => api.post("/pipeline-statuses", data).then((r) => r.data);
export const updatePipelineStatus = (id, data) => api.put(`/pipeline-statuses/${id}`, data).then((r) => r.data);
export const deletePipelineStatus = (id) => api.delete(`/pipeline-statuses/${id}`).then((r) => r.data);
export const createCallOutcome = (data) => api.post("/call-outcomes", data).then((r) => r.data);
export const updateCallOutcome = (id, data) => api.put(`/call-outcomes/${id}`, data).then((r) => r.data);
export const deleteCallOutcome = (id) => api.delete(`/call-outcomes/${id}`).then((r) => r.data);

// Rinkel telephony
export const getRinkelStatus = () => api.get("/integrations/rinkel/status", { params: { base_url: window.location.origin } }).then((r) => r.data);
export const registerRinkelWebhooks = (testOnly) => api.post("/integrations/rinkel/webhooks/register", { base_url: window.location.origin, test_only: testOnly }).then((r) => r.data);
export const getLeadCalls = (leadId) => api.get(`/leads/${leadId}/calls`).then((r) => r.data);
export const getCallQueue = () => api.get("/calls/queue").then((r) => r.data);
export const linkCall = (callId, leadId) => api.post(`/calls/${callId}/link`, { lead_id: leadId }).then((r) => r.data);
export const ignoreCall = (callId) => api.post(`/calls/${callId}/ignore`).then((r) => r.data);
export const fetchRecording = (callId, kind = "recording") =>
  api.get(`/calls/${callId}/recording`, { params: { kind }, responseType: "blob" }).then((r) => r.data);
export const getRinkelNumbers = () => api.get("/integrations/rinkel/numbers").then((r) => r.data);
export const saveRinkelSettings = (data) => api.put("/integrations/rinkel/settings", data).then((r) => r.data);
export const getRinkelAgents = () => api.get("/integrations/rinkel/agents").then((r) => r.data);
export const getRinkelUsers = () => api.get("/integrations/rinkel/users").then((r) => r.data);
export const getLiveCalls = () => api.get("/calls/live").then((r) => r.data);
export const dialLead = (leadId) => api.post("/calls/dial", { lead_id: leadId }).then((r) => r.data);
export const getCallReportList = (period, userId) => api.get("/reports/calls/list", { params: { period, user_id: userId || undefined } }).then((r) => r.data);
export const getCallReport = (period) => api.get("/reports/calls", { params: { period } }).then((r) => r.data);

export const addLeadActivity = (leadId, type, detail) => api.post(`/leads/${leadId}/activity`, { type, detail }).then((r) => r.data);

// Vragen & suggesties
export const getFeedback = () => api.get("/feedback").then((r) => r.data);
export const getFeedbackUnread = () => api.get("/feedback/unread-count").then((r) => r.data);
export const createFeedback = (data) => api.post("/feedback", data).then((r) => r.data);
export const replyFeedback = (id, text) => api.post(`/feedback/${id}/reply`, { text }).then((r) => r.data);
export const setFeedbackStatus = (id, status) => api.put(`/feedback/${id}/status`, { status }).then((r) => r.data);
export const markFeedbackRead = (id) => api.post(`/feedback/${id}/read`).then((r) => r.data);

// Agenda
export const getAdvisors = () => api.get("/advisors").then((r) => r.data);
export const getAvailability = (uid) => api.get(`/availability/${uid}`).then((r) => r.data);
export const saveAvailability = (uid, data) => api.put(`/availability/${uid}`, data).then((r) => r.data);
export const addAvailabilityBlock = (uid, data) => api.post(`/availability/${uid}/blocks`, data).then((r) => r.data);
export const deleteAvailabilityBlock = (uid, id) => api.delete(`/availability/${uid}/blocks/${id}`).then((r) => r.data);
export const getSlots = (uid, start, days = 7, exclude) => api.get(`/availability/${uid}/slots`, { params: { start, days, exclude: exclude || undefined } }).then((r) => r.data);
export const getAppointments = (start, end, userId) => api.get("/appointments", { params: { start, end, user_id: userId || undefined } }).then((r) => r.data);
export const getAssignees = () => api.get("/appointments/assignees").then((r) => r.data);
export const getLeadAppointments = (leadId) => api.get(`/leads/${leadId}/appointments`).then((r) => r.data);
export const createAppointment = (data) => api.post("/appointments", data).then((r) => r.data);
export const updateAppointment = (id, data) => api.put(`/appointments/${id}`, data).then((r) => r.data);
export const deleteAppointment = (id) => api.delete(`/appointments/${id}`).then((r) => r.data);

// Streaming AI suggestion via SSE-over-POST.
export async function streamSuggestion({ prospect_said, call_type, session_id, lead_context }, onDelta, onDone, onError) {
  try {
    const resp = await fetch(`${API}/ai/suggest`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}) },
      body: JSON.stringify({ prospect_said, call_type, session_id, lead_context }),
    });
    if (!resp.ok || !resp.body) throw new Error("Netwerkfout");
    const reader = resp.body.getReader();
    const decoder = new TextDecoder();
    let buffer = "";
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();
      for (const part of parts) {
        const line = part.trim();
        if (!line.startsWith("data:")) continue;
        const payload = JSON.parse(line.slice(5).trim());
        if (payload.delta) onDelta(payload.delta);
        if (payload.error) onError && onError(payload.error);
        if (payload.done) onDone && onDone();
      }
    }
    onDone && onDone();
  } catch (e) {
    onError && onError(e.message);
  }
}

export const getLeadNotifications = () => api.get("/notifications/leads").then((r) => r.data);
export const markLeadNotificationsSeen = () => api.post("/notifications/leads/seen").then((r) => r.data);
export const addSale = (leadId, serviceId, note = "") => api.post(`/leads/${leadId}/sales`, { service_id: serviceId, note }).then((r) => r.data);
export const removeSale = (leadId, saleId) => api.delete(`/leads/${leadId}/sales/${saleId}`).then((r) => r.data);
export const getSourceReport = (days) => api.get("/reports/sources", { params: { days } }).then((r) => r.data);
export const getCallMethod = () => api.get("/calls/method").then((r) => r.data);
export const registerWebphoneDial = (leadId) => api.post("/calls/dial-intent", { lead_id: leadId }).then((r) => r.data);
export const getContentVersions = (itemId) => api.get("/content/versions", { params: itemId ? { item_id: itemId } : {} }).then((r) => r.data);
export const addAdminNote = (leadId, text) => api.post(`/leads/${leadId}/admin-notes`, { text }).then((r) => r.data);
export const editAdminNote = (leadId, id, text) => api.put(`/leads/${leadId}/admin-notes/${id}`, { text }).then((r) => r.data);
export const removeAdminNote = (leadId, id) => api.delete(`/leads/${leadId}/admin-notes/${id}`).then((r) => r.data);
export const getLeadCallQueue = () => api.get("/leads/call-queue").then((r) => r.data);
export const getPermissionList = () => api.get("/permissions").then((r) => r.data);
export const setUserPermissions = (id, permissions) => api.put(`/users/${id}/permissions`, { permissions }).then((r) => r.data);
